module.exports = __webpack_public_path__ + "img/add-s-5.c0c676b4.png";